import React, { useState, useEffect } from 'react';
import { get, post, put, del, openProtectedFile } from '../utils/api';
import { useAuth } from '../context/AuthContext';

const ROLE_LABELS = { super_admin:'Super Admin', admin:'Admin', sales_manager:'Sales Manager',
  production_supervisor:'Production Supervisor',
  inventory_officer:'Inventory Officer',
  content_sales:'Content & Sales',
  production_staff:'Production Staff',
  tailor:'Tailor',
  driver:'Driver',
  auditor:'Auditor',
  procurement_logistics_officer:'Procurement & Logistics Officer',
  front_desk_officer:'Front Desk Officer',
  hr_officer:'HR Officer'
};

export default function Users() {
  const { user: currentUser, hasPermission } = useAuth();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [modal, setModal] = useState(null);
  const [profileModal, setProfileModal] = useState(null);
  const [pendingChanges, setPendingChanges] = useState([]);
  const [showPendingChanges, setShowPendingChanges] = useState(false);

  const load = () => {
    setLoading(true);
    get('/users').then(d => setUsers(d.data)).finally(() => setLoading(false));
  };
  useEffect(() => {
    load();
    if (['super_admin'].includes(currentUser?.role)) {
      get('/payroll/staff/pending-changes').then(d=>setPendingChanges(d.data||[])).catch(()=>{});
    }
  }, []);

  return (
    <div>
      <div className="flex-between mb-lg">
        <h2 className="page-title">Users & Roles</h2>
        <div style={{display:'flex',gap:8,alignItems:'center'}}>
          {currentUser?.role==='super_admin' && pendingChanges.length > 0 && (
            <button className="btn btn-outline" style={{color:'#8B5E0A',borderColor:'#8B5E0A',position:'relative'}}
              onClick={()=>setShowPendingChanges(!showPendingChanges)}>
              ⏳ {pendingChanges.length} Pending Change{pendingChanges.length>1?'s':''}
            </button>
          )}
        </div>
      </div>
      {showPendingChanges && pendingChanges.length > 0 && (
        <div style={{background:'#FFF3DC',border:'1px solid #F0D9A0',borderRadius:10,padding:20,marginBottom:20}}>
          <div style={{fontWeight:700,fontSize:14,color:'#8B5E0A',marginBottom:14}}>⏳ Pending Staff Record Changes</div>
          {pendingChanges.map(c=>(
            <div key={c.id} style={{background:'#fff',borderRadius:8,padding:14,marginBottom:10,border:'1px solid #E8E0D4'}}>
              <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:8}}>
                <div>
                  <div style={{fontWeight:600,fontSize:13}}>{c.staff_name}</div>
                  <div style={{fontSize:11,color:'#8A8A8A'}}>Requested by {c.requested_by_name} · {new Date(c.requested_at).toLocaleDateString('en-NG',{day:'numeric',month:'short',year:'numeric'})}</div>
                </div>
                <div style={{display:'flex',gap:6}}>
                  <button className="btn btn-primary btn-sm" onClick={async()=>{
                    if (!window.confirm('Approve these changes for '+c.staff_name+'?')) return;
                    await put('/payroll/staff/pending-changes/'+c.id+'/approve', {});
                    get('/payroll/staff/pending-changes').then(d=>setPendingChanges(d.data||[]));
                    load();
                  }}>✓ Approve</button>
                  <button className="btn btn-outline btn-sm" style={{color:'#8F2E24',borderColor:'#8F2E24'}} onClick={async()=>{
                    const reason = window.prompt('Reason for rejection:');
                    if (reason===null) return;
                    await put('/payroll/staff/pending-changes/'+c.id+'/reject', {rejection_reason:reason});
                    get('/payroll/staff/pending-changes').then(d=>setPendingChanges(d.data||[]));
                  }}>✕ Reject</button>
                </div>
              </div>
              <div style={{fontSize:12,color:'#3B2A21'}}>
                <strong>Proposed changes:</strong>
                {Object.entries(c.changes||{}).map(([k,v])=>(
                  <span key={k} style={{display:'inline-block',background:'#F2EFE7',borderRadius:4,padding:'2px 8px',margin:'2px',fontSize:11}}>
                    {k.replace(/_/g,' ')}: <strong>{String(v)}</strong>
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
      <div className="tbl-wrap">
        {loading ? <div className="spinner"></div> : (
          <table>
            <thead><tr><th>Name</th><th>Email</th><th>Role</th><th>Status</th><th>Last Login</th><th></th></tr></thead>
            <tbody>
              {users.map(u => (
                <tr key={u.id}>
                  <td style={{fontWeight:500}}>{u.name}{u.id===currentUser.id&&<span className="text-muted text-xs" style={{marginLeft:8}}>(you)</span>}</td>
                  <td>{u.email}</td>
                  <td><span className="badge b-grey">{ROLE_LABELS[u.role]}</span></td>
                  <td><span className={'badge '+(u.is_active?'b-paid':'b-grey')}>{u.is_active?'Active':'Inactive'}</span></td>
                  <td className="text-muted text-sm">{u.last_login?new Date(u.last_login).toLocaleDateString('en-NG'):'Never'}</td>
                  <td>
                    {(currentUser?.role === 'super_admin' || hasPermission('staff_profile:read')) && (
                      <button className="btn btn-ghost btn-sm" style={{marginRight:4}}
                        onClick={() => setProfileModal(u)}>👤 Profile</button>
                    )}
                    {['super_admin','admin'].includes(currentUser?.role) && u.id!==currentUser.id &&
                    <button className="btn btn-ghost btn-sm" onClick={() => setModal(u)}>Edit</button>}
                    {hasPermission('users:write') && (
                      <button className="btn btn-outline btn-sm" style={{fontSize:10,marginLeft:4}}
                        onClick={async () => {
                          const pin = window.prompt('Set 4-digit kiosk PIN for ' + u.name + ':');
                          if (!pin) return;
                          if (!/^\d{4}$/.test(pin)) { alert('PIN must be exactly 4 digits'); return; }
                          try {
                            await post('/kiosk/set-pin', { user_id: u.id, pin });
                            alert('PIN set successfully for ' + u.name);
                          } catch (err) { alert(err.message); }
                        }}>Set PIN</button>
                    )}
                    {currentUser?.role === 'super_admin' && u.is_active && (
                      <button
                        className="btn btn-outline btn-sm"
                        style={{
                          fontSize: 10,
                          marginLeft: 4,
                          color: '#1E4FAD',
                          borderColor: '#1E4FAD'
                        }}
                        onClick={async () => {
                          if (
                            !window.confirm(
                              'Send a secure password-reset link to ' +
                              u.name +
                              ' at ' +
                              u.email +
                              '?'
                            )
                          ) {
                            return;
                          }
                    
                          try {
                            const result = await post(
                              '/users/' +
                                u.id +
                                '/send-password-reset',
                              {}
                            );
                    
                            alert(result.message);
                          } catch (err) {
                            alert(err.message);
                          }
                        }}
                      >
                        🔐 Send Reset Link
                      </button>
                    )}
                    {currentUser?.role === 'super_admin' && u.is_active && (
                      <button className="btn btn-outline btn-sm" style={{fontSize:10,marginLeft:4,color:'#556B2F',borderColor:'#556B2F'}}
                        onClick={async () => {
                          if (!window.confirm('Send bio-data form to ' + u.name + '?')) return;
                          try {
                            await post('/biodata/send/' + u.id, {});
                            alert('Bio-data form sent to ' + u.name);
                          } catch(err) { alert(err.message); }
                        }}>📋 Bio-Data</button>
                    )}
                    {['super_admin','hr_officer'].includes(currentUser?.role) && u.is_active && (
                      <button className="btn btn-outline btn-sm" style={{fontSize:10,marginLeft:4,color:'#A8893D',borderColor:'#A8893D'}}
                        onClick={async () => {
                          if (!window.confirm('Send payroll enrolment form to ' + u.name + '?')) return;
                          try {
                            await post('/biodata/payroll/send/' + u.id, {});
                            alert('Payroll enrolment form sent to ' + u.name);
                          } catch(err) { alert(err.message); }
                        }}>💳 Payroll</button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      {modal !== null && (
        <UserModal user={modal} onClose={() => setModal(null)} onSaved={() => { setModal(null); load(); }} />
      )}
      {profileModal && (
        <StaffProfileModal user={profileModal} onClose={() => setProfileModal(null)} />
      )}
    </div>
  );
}

function UserModal({ user, onClose, onSaved }) {
  const isEdit = user?.id;
  const [form, setForm] = useState(isEdit
    ? {
        name: user.name,
        email: user.email,
        role: user.role,
        is_active: user.is_active,
        date_joined: user.date_joined?.split('T')[0]||'',
        date_of_birth: user.date_of_birth?.split('T')[0]||'',
        kiosk_pin: '',
        blood_group: user.blood_group||'',
        emergency_contact_name: user.emergency_contact_name||'',
        emergency_contact_phone: user.emergency_contact_phone||''
      }
    : { name:'', email:'', password:'', role:'sales_manager', date_joined:'', date_of_birth:'', blood_group:'', emergency_contact_name:'', emergency_contact_phone:'' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const submit = async () => {
    setSaving(true);
    try {
        if (!isEdit) {
          throw new Error(
            'New staff accounts must be created through controlled onboarding'
          );
        }

        await put('/users/'+user.id, form);
      onSaved();
    } catch (err) { setError(err.message); } finally { setSaving(false); }
  };
  return (
    <div className="modal-overlay"><div className="modal">
      <div className="modal-hdr">
        <span className="modal-title">Edit User</span>
        <button className="btn btn-ghost btn-sm" onClick={onClose}>✕</button>
      </div>
      <div className="modal-body">
        {error && <div className="alert alert-error mb-md">{error}</div>}
        <div className="form-row">
          <div className="form-group"><label className="form-label">Full Name *</label>
            <input className="form-control" value={form.name} onChange={e=>setForm({...form,name:e.target.value})} /></div>
          <div className="form-group"><label className="form-label">Email *</label>
            <input type="email" className="form-control" value={form.email} onChange={e=>setForm({...form,email:e.target.value})} /></div>
        </div>
        {!isEdit && (
          <div className="form-group"><label className="form-label">Password *</label>
            <input type="password" className="form-control" value={form.password||''} onChange={e=>setForm({...form,password:e.target.value})} /></div>
        )}
        <div className="form-row">
          <div className="form-group"><label className="form-label">Role</label>
            <select className="form-control" value={form.role} onChange={e=>setForm({...form,role:e.target.value})}>
              <option value="super_admin">Super Admin</option>
              <option value="admin">Admin</option>
              <option value="sales_manager">Sales Manager</option>
              <option value="content_sales">Content & Sales</option>
              <option value="production_supervisor">Production Supervisor</option>
              <option value="production_assistant">Production Assistant</option>
              <option value="inventory_officer">Inventory Officer</option>
              <option value="production_staff">Production Staff</option>
              <option value="tailor">Tailor</option>
              <option value="driver">Driver</option>
              <option value="auditor">Auditor</option>
              <option value="procurement_logistics_officer">Procurement &amp; Logistics Officer</option>
              <option value="front_desk_officer">Front Desk Officer</option>
              <option value="hr_officer">HR Officer</option>
            </select></div>
          {isEdit && (
            <div className="form-group"><label className="form-label">Status</label>
              <select className="form-control" value={form.is_active} onChange={e=>setForm({...form,is_active:e.target.value==='true'})}>
                <option value="true">Active</option><option value="false">Inactive</option>
              </select></div>
          )}
        </div>
        <div className="form-row">
          <div className="form-group"><label className="form-label">Date Joined</label>
            <input type="date" className="form-control" value={form.date_joined||''}
              onChange={e=>setForm({...form,date_joined:e.target.value})} />
            <div className="form-hint">Used for leave anniversary reset</div>
          </div>
          <div className="form-group"><label className="form-label">Date of Birth</label>
            <input type="date" className="form-control" value={form.date_of_birth||''}
              onChange={e=>setForm({...form,date_of_birth:e.target.value})} />
            <div className="form-hint">Used for birthday notifications and bonus</div>
          </div>
          <div className="form-group"><label className="form-label">Kiosk PIN (4 digits)</label>
            <input type="password" className="form-control" maxLength={4} value={form.kiosk_pin||''}
              onChange={e=>setForm({...form,kiosk_pin:e.target.value})}
              placeholder="4-digit PIN for break kiosk" />
          </div>
        </div>
        <div className="form-row">
          <div className="form-group"><label className="form-label">Blood Group</label>
            <select className="form-control" value={form.blood_group||''}
              onChange={e=>setForm({...form,blood_group:e.target.value})}>
              <option value="">Not set</option>
              {['A+','A-','B+','B-','AB+','AB-','O+','O-'].map(bg=>(
                <option key={bg} value={bg}>{bg}</option>
              ))}
            </select>
          </div>
        </div>
        <div className="form-row">
          <div className="form-group"><label className="form-label">Emergency Contact Name</label>
            <input className="form-control" value={form.emergency_contact_name||''}
              onChange={e=>setForm({...form,emergency_contact_name:e.target.value})}
              placeholder="Next of kin name" />
          </div>
          <div className="form-group"><label className="form-label">Emergency Contact Phone</label>
            <input className="form-control" value={form.emergency_contact_phone||''}
              onChange={e=>setForm({...form,emergency_contact_phone:e.target.value})}
              placeholder="Next of kin phone number" />
          </div>
        </div>
      </div>
      <div className="modal-ftr">
        <button className="btn btn-outline" onClick={onClose}>Cancel</button>
        <button className="btn btn-primary" onClick={submit} disabled={saving}>{saving?'Saving...':'Save Changes'}</button>
      </div>
    </div></div>
  );
}

function StaffProfileModal({ user, onClose }) {
  const [activeTab, setActiveTab] = useState('biodata');
  const [profile, setProfile] = useState(null);
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sending, setSending] = useState(null);
  const { user: currentUser, hasPermission } = useAuth();
  const [approving, setApproving] = useState(false);

  useEffect(() => {
    Promise.all([
      get('/users/' + user.id + '/profile'),
      get('/document-templates'),
    ]).then(([u, t]) => {
      setProfile(u.data || user);
      setTemplates((t.data||[]).filter(d => d.status === 'active'));
    }).catch(()=>{}).finally(() => setLoading(false));
  }, [user.id]);

  const approvePayroll = async () => {
    if (!window.confirm('Approve payroll enrolment for ' + user.name + '?')) return;
    setApproving(true);
    try {
      await post('/biodata/payroll/approve/' + user.id, {});
      const refreshed = await get('/users/' + user.id + '/profile');
      setProfile(refreshed.data);
      alert('Payroll enrolment approved.');
    } catch(e) { alert(e.message); }
    finally { setApproving(false); }
  };

  const sendDocument = async (templateId, templateTitle) => {
    if (!window.confirm('Send "' + templateTitle + '" to ' + user.name + '?')) return;
    setSending(templateId);
    try {
      await post('/biodata/send-document', { user_id: user.id, template_id: templateId });
      alert('Document sent to ' + user.name + ' successfully.');
    } catch(e) { alert(e.message); }
    finally { setSending(null); }
  };

  const fmt = v => v || <span style={{color:'#C0B8B0',fontStyle:'italic'}}>Not provided</span>;
  const fmtDate = v => v ? new Date(v).toLocaleDateString('en-NG', {day:'numeric',month:'long',year:'numeric'}) : null;

  const Row = ({label, value}) => (
    <tr>
      <td style={{padding:'8px 12px',color:'#8A8A8A',fontSize:12,width:'40%',fontWeight:600,textTransform:'uppercase',letterSpacing:'.04em'}}>{label}</td>
      <td style={{padding:'8px 12px',fontSize:13,color:'#2C1F16',borderBottom:'1px solid #F2EFE7'}}>{fmt(value)}</td>
    </tr>
  );

  return (
    <div className="modal-overlay">
      <div className="modal" style={{maxWidth:680,width:'95vw'}}>
        <div className="modal-hdr" style={{background:'#3B2A21',borderRadius:'12px 12px 0 0'}}>
          <div>
            <div style={{color:'#A8893D',fontSize:16,fontWeight:700}}>{user.name}</div>
            <div style={{color:'rgba(242,239,231,.5)',fontSize:12,marginTop:2}}>{user.role?.replace(/_/g,' ')} · {user.email}</div>
          </div>
          <button className="btn btn-ghost btn-sm" style={{color:'#F2EFE7'}} onClick={onClose}>✕</button>
        </div>

        {/* Tabs */}
        <div style={{display:'flex',borderBottom:'1px solid #E8E0D4',background:'#F9F8F5'}}>
          {[['biodata','📋 Bio-Data'],['payroll','💳 Payroll'],['guarantor','🤝 Guarantor'],['documents','📄 Documents']].map(([key,label])=>(
            <button key={key} onClick={()=>setActiveTab(key)}
              style={{padding:'12px 20px',border:'none',background:'none',cursor:'pointer',
                fontSize:13,fontWeight:activeTab===key?700:400,
                color:activeTab===key?'#556B2F':'#8A8A8A',
                borderBottom:activeTab===key?'2px solid #556B2F':'2px solid transparent'}}>
              {label}
            </button>
          ))}
        </div>

        <div className="modal-body" style={{maxHeight:'70vh',overflowY:'auto'}}>
          {loading ? <div className="spinner"/> : (
            <>
              {activeTab === 'biodata' && (
                <div>
                  {profile?.biodata_submitted_at ? (
                    <div style={{background:'#E8F5EB',borderRadius:8,padding:'8px 14px',
                      marginBottom:16,fontSize:12,color:'#2E6B3A'}}>
                      ✅ Bio-data submitted on {fmtDate(profile.biodata_submitted_at)}
                    </div>
                  ) : (
                    <div style={{background:'#FFF3DC',borderRadius:8,padding:'8px 14px',
                      marginBottom:16,fontSize:12,color:'#8B5E0A'}}>
                      ⚠ Bio-data form not yet submitted
                    </div>
                  )}

                  {/* Personal */}
                  <div style={{fontSize:11,fontWeight:700,color:'#556B2F',textTransform:'uppercase',
                    letterSpacing:'.08em',marginBottom:8}}>Personal Information</div>
                  <table style={{width:'100%',borderCollapse:'collapse',marginBottom:20}}>
                    <tbody>
                      <Row label="Full Name" value={[profile?.title, profile?.name, profile?.middle_name].filter(Boolean).join(' ')} />
                      <Row label="Maiden Name" value={profile?.maiden_name} />
                      <Row label="Date of Birth" value={fmtDate(profile?.date_of_birth)} />
                      <Row label="Place of Birth" value={profile?.place_of_birth} />
                      <Row label="Sex" value={profile?.sex} />
                      <Row label="Marital Status" value={profile?.marital_status} />
                      <Row label="Nationality" value={profile?.nationality} />
                      <Row label="State of Origin" value={profile?.state_of_origin} />
                      <Row label="LGA" value={profile?.lga} />
                      <Row label="Permanent Address" value={profile?.permanent_address} />
                      <Row label="Residential Address" value={profile?.residential_address} />
                      <Row label="Email" value={profile?.email} />
                    </tbody>
                  </table>

                  {/* Health */}
                  <div style={{fontSize:11,fontWeight:700,color:'#556B2F',textTransform:'uppercase',
                    letterSpacing:'.08em',marginBottom:8}}>Health Record</div>
                  <table style={{width:'100%',borderCollapse:'collapse',marginBottom:20}}>
                    <tbody>
                      <Row label="Blood Group" value={profile?.blood_group} />
                      <Row label="Genotype" value={profile?.genotype} />
                      <Row label="Health History" value={profile?.health_history} />
                    </tbody>
                  </table>

                  {/* Emergency */}
                  <div style={{fontSize:11,fontWeight:700,color:'#556B2F',textTransform:'uppercase',
                    letterSpacing:'.08em',marginBottom:8}}>Emergency Contact</div>
                  <table style={{width:'100%',borderCollapse:'collapse'}}>
                    <tbody>
                      <Row label="Name" value={profile?.emergency_contact_name} />
                      <Row label="Phone" value={profile?.emergency_contact_phone} />
                      <Row label="Email" value={profile?.emergency_contact_email} />
                      <Row label="Relationship" value={profile?.emergency_contact_relationship} />
                      <Row label="Sex" value={profile?.emergency_contact_sex} />
                    </tbody>
                  </table>
                </div>
              )}

              {activeTab === 'payroll' && (
                <div>
                  {profile?.payroll_enrolment_submitted_at ? (
                    <div style={{background:'#E8F5EB',borderRadius:8,padding:'8px 14px',
                      marginBottom:16,fontSize:12,color:'#2E6B3A'}}>
                      ✅ Payroll enrolment submitted on {new Date(profile.payroll_enrolment_submitted_at).toLocaleDateString('en-NG',{day:'numeric',month:'long',year:'numeric'})}
                      &nbsp;·&nbsp; Status: <strong>{profile.payroll_enrolment_status?.replace(/_/g,' ')}</strong>
                    </div>
                  ) : (
                    <div style={{background:'#FFF3DC',borderRadius:8,padding:'8px 14px',
                      marginBottom:16,fontSize:12,color:'#8B5E0A'}}>
                      ⚠ Payroll enrolment not yet submitted
                    </div>
                  )}
                  <table style={{width:'100%',borderCollapse:'collapse'}}>
                    <tbody>
                      <Row label="Bank Name" value={profile?.bank_name} />
                      <Row label="Account Name" value={profile?.bank_account_name} />
                      <Row label="Account Number" value={profile?.bank_account_number} />
                      <Row label="Account Type" value={profile?.bank_account_type} />
                      <Row label="Enrolment Status" value={profile?.payroll_enrolment_status?.replace(/_/g,' ')} />
                      <Row label="Account Name Explanation" value={profile?.account_name_diff_explanation} />
                    </tbody>
                  </table>
                  {currentUser?.role === 'super_admin' && profile?.payroll_enrolment_status === 'pending_verification' && (
                    <button className="btn btn-primary btn-sm" style={{marginTop:16}}
                      disabled={approving} onClick={approvePayroll}>
                      {approving ? 'Approving...' : '✓ Approve Payroll Enrolment'}
                    </button>
                  )}
                  {profile?.payroll_verified_at && (
                    <div style={{marginTop:12,fontSize:12,color:'#8A8A8A'}}>
                      Approved on {new Date(profile.payroll_verified_at).toLocaleDateString('en-NG',{day:'numeric',month:'long',year:'numeric'})}
                    </div>
                  )}
                </div>
              )}
              {activeTab === 'guarantor' && (
                <GuarantorTabPanel userId={user.id} />
              )}

              {activeTab === 'documents' && (
                <div>
                  <p style={{fontSize:13,color:'#8A8A8A',marginBottom:16}}>
                    Send document templates to this staff member for completion.
                  </p>
                  {templates.length === 0 ? (
                    <div className="empty-state"><p>No active document templates found.</p></div>
                  ) : (
                    <div style={{display:'flex',flexDirection:'column',gap:10}}>
                      {templates.map(t => (
                        <div key={t.id} style={{background:'#F9F8F5',borderRadius:10,
                          padding:'14px 16px',display:'flex',justifyContent:'space-between',
                          alignItems:'center',border:'1px solid #E8E0D4'}}>
                          <div>
                            <div style={{fontWeight:600,fontSize:13,color:'#2C1F16'}}>{t.title}</div>
                            <div style={{fontSize:11,color:'#8A8A8A',marginTop:2}}>{t.document_type}</div>
                          </div>
                          <button className="btn btn-outline btn-sm"
                            style={{color:'#556B2F',borderColor:'#556B2F',fontSize:11}}
                            disabled={sending===t.id}
                            onClick={()=>sendDocument(t.id, t.title)}>
                            {sending===t.id ? 'Sending...' : '📤 Send'}
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              )}
            </>
          )}
        </div>
        <div className="modal-ftr">
          <button className="btn btn-outline" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}

function GuarantorTabPanel({ userId }) {
  const [data, setData] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState('');

  React.useEffect(() => {
    get('/prospects/guarantor-by-user/' + userId)
      .then(d => setData(d.data))
      .catch(e => setError(e.message || 'No guarantor record found'))
      .finally(() => setLoading(false));
  }, [userId]);

  const fmt = v => v || React.createElement('span', {style:{color:'#C0B8B0',fontStyle:'italic'}}, 'Not provided');
  const fmtDate = v => v ? new Date(v).toLocaleDateString('en-NG',{day:'numeric',month:'long',year:'numeric'}) : '—';

  const Row = ({label, value}) => (
    <tr>
      <td style={{padding:'7px 12px',color:'#8A8A8A',fontSize:11,width:'40%',fontWeight:600,textTransform:'uppercase',letterSpacing:'.04em'}}>{label}</td>
      <td style={{padding:'7px 12px',fontSize:13,color:'#2C1F16',borderBottom:'1px solid #F2EFE7'}}>{fmt(value)}</td>
    </tr>
  );

  if (loading) return <div className="spinner"/>;

  if (error || !data) return (
    <div style={{padding:24,textAlign:'center',color:'#8A8A8A',fontSize:13}}>
      <div style={{fontSize:32,marginBottom:8}}>🤝</div>
      No guarantor record found for this staff member.
    </div>
  );

  const statusBg = data.status==='approved'?'#E8F5EB':data.status==='submitted'?'#FFF3DC':'#F5F5F5';
  const statusColor = data.status==='approved'?'#2E6B3A':data.status==='submitted'?'#8B5E0A':'#8A8A8A';

  return (
    <div>
      <div style={{background:statusBg,borderRadius:8,padding:'8px 14px',marginBottom:16,fontSize:12,color:statusColor}}>
        {data.status==='approved'?'✅':'⏳'} Status: <strong>{data.status}</strong>
        {data.submitted_at && ` · Submitted ${fmtDate(data.submitted_at)}`}
        {data.verified_at && ` · Verified ${fmtDate(data.verified_at)}`}
      </div>
      <div style={{fontSize:11,fontWeight:700,color:'#556B2F',textTransform:'uppercase',letterSpacing:'.08em',marginBottom:8}}>Guarantor Information</div>
      <table style={{width:'100%',borderCollapse:'collapse',marginBottom:16}}>
        <tbody>
          <Row label="Full Name" value={data.full_name} />
          <Row label="Email" value={data.email} />
          <Row label="Phone" value={data.phone} />
          <Row label="Address" value={data.address} />
          <Row label="Relationship" value={data.relationship} />
          <Row label="Years Known" value={data.years_known} />
          <Row label="Occupation" value={data.occupation} />
          <Row label="Employer" value={data.employer} />
          <Row label="ID Number" value={data.nin} />
        </tbody>
      </table>
      {data.uploaded_documents && Object.keys(data.uploaded_documents).length > 0 && (
        <div style={{marginBottom:12}}>
          <div style={{fontSize:11,fontWeight:700,color:'#556B2F',textTransform:'uppercase',letterSpacing:'.08em',marginBottom:8}}>Uploaded Documents</div>
          <div style={{display:'flex',gap:8,flexWrap:'wrap'}}>
            {Object.entries(data.uploaded_documents).map(([key])=>(
                <button
                  key={key}
                  type="button"
                  onClick={() =>
                    openProtectedFile(
                      '/prospects/guarantors/' +
                      data.id +
                      '/documents/' +
                      encodeURIComponent(key)
                    ).catch(error =>
                      window.alert(error.message)
                    )
                  }
                  style={{padding:'6px 12px',borderRadius:8,background:'#F2EFE7',color:'#556B2F',
                    fontSize:12,border:'1px solid #C8BFA8',cursor:'pointer'}}>
                  📎 {key.replace(/_/g,' ')}
                </button>
              ))}
          </div>
        </div>
      )}
      {data.verification_notes && (
        <div style={{background:'#F9F8F5',borderRadius:8,padding:12,fontSize:12,color:'#555'}}>
          <strong>Verification Notes:</strong> {data.verification_notes}
        </div>
      )}
    </div>
  );
}
